<template>
    <div class="collapsible-container">
      <section class="header" @click="toggleCollapse">
        <h3 class="header-title"> {{ title }} </h3>
        <div class="d-flex gap-1">
          <!-- slot -->
          <slot name="right"></slot>
          <div class="collapse-icon">
            <i class="el-icon-arrow-down" v-if="!isCollapsed" @click.stop="toggleCollapse"></i>
            <i class="el-icon-arrow-up" v-if="isCollapsed" @click.stop="toggleCollapse"></i>
          </div>
        </div>
      </section>
      <!-- body -->
      <el-collapse-transition>
        <section class="body" v-if="!isCollapsed">
          <!-- horizontal line -->
          <hr />
          <section class="mt-1">
            <slot name="body"></slot>
          </section>
        </section>
      </el-collapse-transition>
    </div>
  </template>

<script>
export default {
  name: 'Collapsible',
  props: {
    title: {
      type: String,
      required: true,
    },
    open: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      isCollapsed: !this.open,
    };
  },
  methods: {
    toggleCollapse() {
      this.isCollapsed = !this.isCollapsed;
    },
  },
};
</script>

  <style lang="scss" scoped>
    .collapsible-container {
      width: 100%;
      background-color: #fff;
      border: 1px solid #ebeef5;
      border-radius: 24px;
      padding: 1.5rem 2rem;
      margin-bottom: 1rem;
      // transition: text-decoration 0.3s ease-in-out;
      // &:hover {
      //   .header h3 {
      //     text-decoration: underline;
      //   }
      // }
      .header {
        cursor: pointer;
        display: flex;
        justify-content: space-between;
        align-items: center;
        h3 {
          color: #2F2F2F;
          margin: 0;
          // font-size: 1.2rem;
          font-weight: 500;
        }
        .collapse-icon {
          border-radius: 200px;
          background-color: #EFF0F6;
          width: 2.5rem;
          height: 2.5rem;
          cursor: pointer;
          padding: 0.5rem;
          display: flex;
          justify-content: center;
          align-items: center;
          i {
            // font-size: 1.2rem;
          }
        }

      }
      hr {
        height: 2px;
        border: none;
        border-radius: 24px;
        background: #ebeef5;
      }
      .body {
        padding: 1rem 0;
      }
    }
  </style>
